'use client'
import Toggle from '@/components/toggle'
import { useState } from 'react'

type Props = { initialIsPrivate?: boolean }
const privateClassName = 'bg-gradient-error'
const publicClassName = 'bg-gradient-secondary'
const PrivateToggle = ({ initialIsPrivate }: Props) => {
    const [isPrivate, setIsPrivate] = useState(!!initialIsPrivate)
    return (
        <div className="mt-1 h-9">
            <Toggle
                options={[
                    {
                        label: <span className="mx-4 font-bold text-giphyWhite">Public</span>,
                        gradientClassName: publicClassName,
                    },
                    {
                        label: <span className="mx-4 font-bold text-giphyWhite">Private</span>,
                        gradientClassName: privateClassName,
                    },
                ]}
                index={!isPrivate ? 0 : 1}
                onTransitionEnd={(index) => {
                    setIsPrivate(index === 1)
                }}
            />
            <input type="hidden" name="is_private" value={isPrivate ? 'true' : 'false'} />
        </div>
    )
}
export default PrivateToggle
